// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"331":"066b41e93dcf62ff","651":"6b0a0a214e3e799c"}[chunkId] + ".js";
};